import { useState, useEffect } from "react";
import {
  mapPayrollToRoles,
  NormalizedPayrollRole,
} from "@/lib/staffing/fromPayroll";
import { getPayrollDataById } from "./payrollDataService";

export function usePayrollRoles(deal: any | undefined) {
  const [payrollRoles, setPayrollRoles] = useState<NormalizedPayrollRole[]>([]);
  const [payrollLoading, setPayrollLoading] = useState(false);

  useEffect(() => {
    const dataId = deal?.kpis?.payroll?.dataId;
    if (!dataId) {
      setPayrollRoles([]);
      return;
    }

    setPayrollLoading(true);
    getPayrollDataById(dataId)
      .then((record) => {
        if (record) setPayrollRoles(mapPayrollToRoles(record));
        else setPayrollRoles([]);
      })
      .catch((err) => {
        console.error("Failed to fetch payroll data:", err);
        setPayrollRoles([]);
      })
      .finally(() => setPayrollLoading(false));
  }, [deal?.kpis?.payroll?.dataId]);

  return { payrollRoles, payrollLoading };
}
